import isFunctionString from './isFunctionString';

/**
 * Utility functions for serializing and deserializing JavaScript/TypeScript values
 */
export default class JsonSerializer {
  /**
   * Serializes an object, converting any functions to string representations
   */
  static serialize(value: any): string {
    return JSON.stringify(value, (key, val) =>
      typeof val === 'function' ? val.toString() : val,
    );
  }

  /**
   * Deserialize a JSON string back into a JavaScript value
   * Converts function strings back to actual functions
   * keep function strings as strings if deserializeFunctions is false
   */
  static deserialize<T = any>(
    serialized: string,
    deserializeFunctions = false,
  ): T {
    return JSON.parse(serialized, (key, value) => {
      if (deserializeFunctions && typeof value === 'string') {
        if (isFunctionString(value)) {
          try {
            // Create a function from the string representation
            return new Function('return ' + value)();
          } catch (error) {
            console.error(`Error parsing function: ${value}`, error);
            return value;
          }
        }
      }
      return value;
    });
  }
}
